import { frontendURL } from 'dashboard/helper/URLHelper';

const WorkflowsRouteView = () => import('./pages/WorkflowsRouteView.vue');
const WorkflowsListPage = () => import('./pages/WorkflowsListPage.vue');
const WorkflowEditorPage = () => import('./pages/WorkflowEditorPage.vue');

const workflowRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/workflows'),
      component: WorkflowsRouteView,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'workflows_index', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'workflows_index',
          component: WorkflowsListPage,
          meta: {
            permissions: ['administrator', 'workflow_view', 'workflow_manage'],
          },
        },
        {
          path: 'new',
          name: 'workflow_new',
          component: WorkflowEditorPage,
          meta: {
            permissions: ['administrator', 'workflow_view', 'workflow_manage'],
          },
        },
        {
          path: ':workflowId',
          name: 'workflow_editor',
          component: WorkflowEditorPage,
          meta: {
            permissions: ['administrator', 'workflow_view', 'workflow_manage'],
          },
        },
      ],
    },
  ],
};

export default workflowRoutes;
